/**
 * Feature Flags Configuration
 *
 * Toggle features on/off without deleting code.
 * Perfect for rolling out features gradually or A/B testing.
 */

export const FEATURE_FLAGS = {
  /**
   * Single Product Mode
   *
   * When true: Simplifies the UI to showcase one hero product
   * When false: Shows full multi-product catalog with carousels, grids, filters
   *
   * Use case: Launch with limited inventory, then expand later
   */
  SINGLE_PRODUCT_MODE: true,
} as const;

// Export individual flags for convenience
export const { SINGLE_PRODUCT_MODE } = FEATURE_FLAGS;
